import React from 'react';
import ReactDOM from 'react-dom/client';
import { App } from './App.js';
// The vendor portal loaded no tokens at all; it now shares the admin look.
import '../../shared/tokens/colors.css';
import '../../shared/tokens/typography.css';
import '../../shared/tokens/motion.css';
import '../../shared/tokens/base.css';
import '../../shared/tokens/screen-theme.css';
import '../../shared/tokens/brand-operations.css';

const root = document.getElementById('root');
if (!root) throw new Error('Root element #root not found');
ReactDOM.createRoot(root).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
